/* ux-compra-sticky — Simplit, 09/09/2026 (auditoría 08/09, hallazgo #3, OK Martin).
   En móvil el botón «Agregar al carrito» de la ficha arranca bajo el pliegue (915 px de 844 en la
   ficha que más vende). Esta barra fija muestra precio + Agregar solo mientras el botón original
   NO está en pantalla, y al tocarla dispara el MISMO botón (el ajax-cart del tema). Espeja el estado
   del botón (Agregando… / Añadida al carrito / Agotado) porque el feedback del tema es inline y
   queda fuera de pantalla. No toca el formulario ni duplica variantes ni cantidad. Solo bajo 768 px.
   Se esconde con un cajón o modal abierto. Reversión: quitar la línea de layout/theme.liquid. */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  if (!mq || !mq.matches) return;
  if (document.getElementById('ux-compra-sticky')) return;
  var btn = document.querySelector('form[action*="/cart/add"] [name="button"], form[action*="/cart/add"] button[type="submit"]');
  if (!btn) return;
  var seccion = btn.closest('[id^="shopify-section"]') || document.body;
  var TXT_BASE = (btn.value || btn.textContent || 'Agregar al carrito').replace(/\s+/g, ' ').trim();

  function estado() { return (btn.value || btn.textContent || '').replace(/\s+/g, ' ').trim(); }
  function agotado() { return btn.disabled || /agotado|sold out|no disponible|unavailable/i.test(estado()); }
  function ocupado() { return btn.classList.contains('disabled') || /agregando|adding/i.test(estado()); }
  function anadida() { return /añadida|agregada|added/i.test(estado()); }
  function tapado() { return /slideout-\w+--open|modal--open|-open\b/.test(document.body.className) || !!document.querySelector('.slideout--active'); }
  function precio() {
    var caja = seccion.querySelector('#product-price') || seccion.querySelector('.price');
    if (!caja) return '';
    var c = caja.querySelectorAll('.price-item--sale, .price-item--regular');
    for (var i = 0; i < c.length; i++) {
      if (c[i].tagName === 'S' || c[i].closest('s') || c[i].offsetParent === null) continue;
      var t = c[i].textContent.replace(/\s+/g, ' ').trim();
      if (t) return t;
    }
    return '';
  }

  var css = document.createElement('style');
  css.id = 'ux-compra-sticky-css';
  css.textContent =
    '#ux-compra-sticky{position:fixed;left:0;right:0;bottom:0;z-index:1299;display:flex;align-items:center;gap:12px;padding:10px 16px calc(10px + env(safe-area-inset-bottom,0));background:#fff;box-shadow:0 -2px 12px rgba(0,0,0,.14);transform:translateY(110%);transition:transform .25s ease;font-family:inherit}' +
    '#ux-compra-sticky.ux-cs--on{transform:none}' +
    '#ux-compra-sticky .ux-cs__precio{font-weight:700;font-size:18px;white-space:nowrap;color:#1a1a1a;min-width:72px}' +
    '#ux-compra-sticky .ux-cs__precio a{color:#1f8a5b;text-decoration:underline;font-size:16px}' +
    /* 18,7 px bold: con blanco sobre el coral de marca el contraste es 3,13, y WCAG AA exige 3,0
       para texto grande (≥18,66 px bold). A 16 px 600 exigía 4,5 y no cumplía. Medido el 09/09. */
    '#ux-compra-sticky .ux-cs__btn{flex:1;height:48px;border:0;border-radius:4px;background:#ea6a5a;color:#fff;font-size:18.7px;font-weight:700;letter-spacing:.2px;cursor:pointer;font-family:inherit}' +
    '#ux-compra-sticky .ux-cs__btn:disabled{opacity:.7;cursor:default}' +
    '#ux-compra-sticky .ux-cs__btn.ux-cs--ok{background:#1f8a5b;opacity:1}' +
    'body.ux-cs-visible #ux-wa-fab{bottom:calc(18px + var(--ux-cs-h,78px))!important;transition:bottom .25s ease}' +
    'body.ux-cs-visible .woot-widget-bubble{bottom:calc(20px + var(--ux-cs-h,78px))!important;transition:bottom .25s ease}';
  document.head.appendChild(css);

  var bar = document.createElement('div');
  bar.id = 'ux-compra-sticky';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Comprar');
  var lbl = document.createElement('div'); lbl.className = 'ux-cs__precio';
  var b2 = document.createElement('button'); b2.type = 'button'; b2.className = 'ux-cs__btn'; b2.textContent = TXT_BASE;
  bar.appendChild(lbl); bar.appendChild(b2);
  document.body.appendChild(bar);

  var botonEnPantalla = true, pendiente = false;
  function pintar() { if (pendiente) return; pendiente = true; requestAnimationFrame(_pintar); }
  function _pintar() {
    pendiente = false;
    var ok = anadida();
    b2.textContent = estado() || TXT_BASE;
    b2.disabled = ocupado() || agotado();
    b2.classList.toggle('ux-cs--ok', ok);
    if (ok) {
      if (!lbl.firstElementChild) { lbl.textContent = ''; var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'Ver carrito'; lbl.appendChild(a); }
    } else {
      var p = precio();
      if (lbl.firstElementChild || lbl.textContent !== p) lbl.textContent = p;
    }
    var on = mq.matches && !botonEnPantalla && !agotado() && !tapado();
    if (on) document.body.style.setProperty('--ux-cs-h', bar.offsetHeight + 'px');
    bar.classList.toggle('ux-cs--on', on);
    document.body.classList.toggle('ux-cs-visible', on);
  }
  b2.addEventListener('click', function () {
    if (agotado() || ocupado()) return;
    btn.click(); // el tema escucha el click del .js-ajax-submit y hace el POST a /cart/add
    pintar();
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { botonEnPantalla = es[0].isIntersecting; pintar(); }, { threshold: 0 }).observe(btn);
  } else {
    var chequear = function () { var r = btn.getBoundingClientRect(); botonEnPantalla = r.bottom > 0 && r.top < window.innerHeight; pintar(); };
    window.addEventListener('scroll', chequear, { passive: true }); chequear();
  }
  if ('MutationObserver' in window) {
    // precio, texto del botón, variante, mensaje «Añadida»: todo cambia dentro de la sección
    new MutationObserver(pintar).observe(seccion, { subtree: true, childList: true, attributes: true, characterData: true });
    // cajones y modales marcan el body
    new MutationObserver(pintar).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (mq.addEventListener) mq.addEventListener('change', pintar); else if (mq.addListener) mq.addListener(pintar);
  pintar();
})();
